import { ReportQueriesEntity } from "../domain/reportQueries.entity";
import { ReportQueries } from "../../../gen/witbooking/backoffice/reportqueries/v1/reportqueries_api_pb";

export function dtoToEntity(dto: ReportQueries[]): ReportQueriesEntity[] {
  if (!dto?.length) {
    return [];
  }
  return dto
    .map(it => it.toObject())
    .map((it, index) => ({
      id: index,
      adults: it.adults,
      babies: it.babies,
      checkIn: it.checkIn,
      checkOut: it.checkOut,
      children: it.children,
      date: it.date,
      hasAvailability: it.hasAvailability,
      ip: it.ip,
      isChain: it.isChain,
      locale: it.locale,
      nights: it.nights,
      occupancy: it.occupancy,
    }));
}
